module.exports = __webpack_public_path__ + "static/fitspot-2-2f4150a8daad86e8bf07c8ce60f9cae2.png";